module.exports = __webpack_public_path__ + "img/airPurifiers_1.23dcb8bd.png";